import _ from 'lodash';

export default function handleReferral(referralQP, interactionQP) {
  // Clear referral if it has already been displayed
  if (_.isNil(interactionQP)) {
    localStorage.removeItem('referral');
  }
  if (!_.isNil(referralQP)) {
    localStorage.setItem('referral', referralQP);
  }
}
